import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './admin-licenses.hbs'
import InactiveLicenses from './inactive-licenses'
import AddLicense from './add-license'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import LicensePanel from './license-panel'

var AdminLicenses = Backbone.View.extend({

	// options.data is information about the licenses and unlinked databases
	// this.licenses is a reference to this.options.data.licenses

	className: 'admin table-hack display-layout admin-licenses',

	events: {
		'click .open-add-license': 'addLicense'
	},

	initialize: function(options) {
		this.options = options || {}
		this.licenses = this.options.data.licenses
		// we're just in admin so no need to get fancy
		this.listenTo(Backbone, 'add:license update:license delete:license activate:license', AdminLicenses.load)
	},

	render: function() {
		this.removeChildren()
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.licenses.licenseManagement'),
			mobileGearHidden: true
		}).render().el, template())

		// sort all licenses by their labels (case insensitive)
		this.licenses = _.sortBy(this.licenses, function(license) {
			return license.label.toUpperCase()
		})
		// separate into active and inactive licenses
		var active = [], inactive = []
		_.each(this.licenses, function(license) {
			license.activated ? active.push(license) : inactive.push(license)
		})

		// render inactive licenses
		if (!_.isEmpty(inactive)) {
			this.inactiveLicenses = new InactiveLicenses({ licenses: inactive })
			this.$('.inactive-licenses').append(this.inactiveLicenses.el)
			this.inactiveLicenses.render()
			this.inactiveLicenses.on('activate:license', AdminLicenses.load)
		}
		// render active licenses
		this.licensePanels = []
		_.each(active, function(license) {
			var panel = new LicensePanel({
				license: license,
				unlinkedDatabases: this.options.data.unlinkedDatabases
			}).render()
			panel.on('refresh', function(data) {
				appDisplay.display(new AdminLicenses({ data: data }))
			})
			this.licensePanels.push(panel)
			this.$('.license-list').append(panel.el)
		}.bind(this))

		return this
	},

	addLicense: function() {
		var form = new AddLicense({
			unlinkedDatabases: this.options.data.unlinkedDatabases
		})
		appDisplay.dialog(form)
		// updating the display might not be necessary in all circumstances
		// but it's necessary in most and it's pretty quick
		form.on('activate:license', AdminLicenses.load)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
	},

	removeChildren: function() {
		_.invokeMap([this.inactiveLicenses], 'remove')
		_.invokeMap(this.licensePanels, 'remove')
	}

}, {

	// generally shouldn't have a view load its own data, but we'll do it in
	// admin to save dev time
	load: function() {
		appDisplay.display($.get('api/admin/licenses'), function(data) {
			return new AdminLicenses({ data: data })
		})
	}

})

export default AdminLicenses

AdminLicenses.__filename__ = 'admin/licenses/admin-licenses.js'
